var visibilitychangeMap = function () {
  if (document.hidden !== undefined) {
    return {
      hidden: "hidden",
      visibilityChange: "visibilitychange"
    };
  } else if (document.webkitHidden !== undefined) {
    return {
      hidden: "webkitHidden",
      visibilityChange: "webkitvisibilitychange"
    };
  } else if (document.msHidden !== undefined) {
    return {
      hidden: "msHidden",
      visibilityChange: "msvisibilitychange"
    };
  }
}();

var supportVisiblityChange = !!visibilitychangeMap;

var watchPageVisiblityChange = function watchPageVisiblityChange(callback, once) {
  if (supportVisiblityChange) {
    var _visibilityChangeCallback;

    document.addEventListener(visibilitychangeMap.visibilityChange, _visibilityChangeCallback = function visibilityChangeCallback(e) {
      if (once) {
        document.removeEventListener(visibilitychangeMap.visibilityChange, _visibilityChangeCallback);
      }

      callback(!document[visibilitychangeMap.hidden]);
    });
  }
};

export { supportVisiblityChange, watchPageVisiblityChange };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-longtask@1.0.1@@ali/aes-tracker-plugin-longtask/es/utils/visibilityChange.js
// module id = null
// module chunks = 